'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFilter = undefined;

var _is = require('ramda/src/is');

var _is2 = _interopRequireDefault(_is);

var _any = require('ramda/src/any');

var _any2 = _interopRequireDefault(_any);

var _pluck = require('ramda/src/pluck');

var _pluck2 = _interopRequireDefault(_pluck);

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _isEmpty = require('ramda/src/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var withFilter = exports.withFilter = function withFilter(Component) {
  return (0, _recompose.compose)((0, _recompose.lifecycle)({
    componentWillReceiveProps: function componentWillReceiveProps() {
      this.forceUpdate();
    }
  }), (0, _recompose.withState)('spotlight', 'setSpotlight', function (props) {
    return _extends({}, props.spotlightOptions);
  }), (0, _recompose.withState)('contents', 'setContents', function (props) {
    return [].concat(_toConsumableArray(props.items));
  }), (0, _recompose.withProps)(function (_ref) {
    var items = _ref.items,
        contents = _ref.contents,
        spotlight = _ref.spotlight,
        spotlightOptions = _ref.spotlightOptions;
    return {
      isBlank: (0, _isEmpty2.default)(items),
      isTree: (0, _pipe2.default)((0, _pluck2.default)('childNodes'), (0, _any2.default)((0, _is2.default)(Array)))(items),
      spotlightedContents: spotlightOptions.engine(spotlight)(contents)
    };
  }), (0, _recompose.withHandlers)({
    onSpotlightChange: function onSpotlightChange(_ref2) {
      var setSpotlight = _ref2.setSpotlight;
      return function (spotlight) {
        return setSpotlight(spotlight);
      };
    },
    onNodeExpand: function onNodeExpand(_ref3) {
      var contents = _ref3.contents,
          setContents = _ref3.setContents;
      return function (node) {
        node.isExpanded = true;
        setContents(contents);
      };
    },
    onNodeCollapse: function onNodeCollapse(_ref4) {
      var contents = _ref4.contents,
          setContents = _ref4.setContents;
      return function (node) {
        node.isExpanded = false;
        setContents(contents);
      };
    },
    onNodeClick: function onNodeClick(_ref5) {
      var contents = _ref5.contents,
          setContents = _ref5.setContents,
          selectFilterValue = _ref5.selectFilterValue,
          id = _ref5.id;
      return function (node) {
        node.isSelected = !node.isSelected;
        setContents(contents);
        selectFilterValue(id, node.id);
      };
    }
  }))(Component);
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-filter/with-filter.js
// module id = 2031
// module chunks = 0